import {
  Box,
  Button,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from "@mui/material/Checkbox";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

const ViewStaffDetails = () => {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();

  const [isDisputeManagement, setDisputeManagement] = useState(
    location.state.staffDetails.isDisputeManagement
  );
  const [isNameLookup, setIsNameLookup] = useState(
    location.state.staffDetails.isNameLookup
  );
  const [isPressureLetter, setIsPressureLetter] = useState(
    location.state.staffDetails.isPressureLetter
  );

  const handleChangeCheckBox = (event) => {
    const { name, checked } = event.target;
    const newValue = checked ? "1" : "0";
    switch (name) {
      case "isDisputeManagement":
        setDisputeManagement(newValue);
        break;
      case "isNameLookup":
        setIsNameLookup(newValue);
        break;
      case "isPressureLetter":
        setIsPressureLetter(newValue);
        break;
      default:
        break;
    }
  };

  const [formValues, setFormValues] = useState({
    firstName: location.state.staffDetails.firstName,
    middleName: location.state.staffDetails.middleName,
    lastName: location.state.staffDetails.lastName,
    username: location.state.staffDetails.username,
    email: location.state.staffDetails.email,
    role: location.state.staffDetails.role,
  });

  const handleFormSubmit = async (values) => {
    const firstname = values.firstName;
    const middlename = values.middleName;
    const lastname = values.lastName;
    const username = values.username;
    const email = values.email;
    const role = values.role;
    const id = location.state.staffDetails.id;
    try {
      const data = {
        firstname,
        middlename,
        lastname,
        username,
        email,
        role,
        isDisputeManagement,
        isNameLookup,
        isPressureLetter,
        id,
      };

      await axios.post("/api/update-staff", data, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      setFormValues({
        ...formValues,
        firstname,
        middlename,
        lastname,
        username,
        email,
        role,
      });

      toast.success("Staff updated successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header title="VIEW STAFF" subtitle="View a staff in the system" />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={formValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="First Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    name="firstName"
                    error={!!touched.firstName && !!errors.firstName}
                    helperText={touched.firstName && errors.firstName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Middle Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.middleName}
                    name="middleName"
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Last Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    name="lastName"
                    error={!!touched.lastName && !!errors.lastName}
                    helperText={touched.lastName && errors.lastName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    name="username"
                    error={!!touched.username && !!errors.username}
                    helperText={touched.username && errors.username}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="email"
                    label="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    name="email"
                    error={!!touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="role-label">Role</InputLabel>
                    <Select
                      labelId="role-label"
                      name="role"
                      value={values.role}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!touched.role && !!errors.role}
                      helperText={touched.role && errors.role}
                    >
                      <MenuItem value=""></MenuItem>
                      <MenuItem value="admin">admin</MenuItem>
                      <MenuItem value="management">management</MenuItem>
                      <MenuItem value="consumer">consumer</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">Access</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isDisputeManagement === "1"}
                            onChange={handleChangeCheckBox}
                            name="isDisputeManagement"
                          />
                        }
                        label="Disputes Management"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isNameLookup === "1"}
                            onChange={handleChangeCheckBox}
                            name="isNameLookup"
                          />
                        }
                        label="Name Lookup"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isPressureLetter === "1"}
                            onChange={handleChangeCheckBox}
                            name="isPressureLetter"
                          />
                        }
                        label="Pressure Letters"
                      />
                    </FormGroup>
                  </FormControl>
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Update Staff
                  </Button>
                </Box>
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  username: yup.string().required("required"),
  email: yup.string().required("required"),
  role: yup.string().required("required"),
});

export default ViewStaffDetails;
